import React from "react";
import { StyledH2 } from "@aureskonnect/react-ui";
import { useTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import NumInput from "react-numeric-input";
import classNames from "classnames";

import { setIsValidateCashFundForum } from "./store";

import "./index.css";

type CashFundAlert = {
    alertForm: string;
    isControleActive: boolean;
    totalBillets: number;
    TotalBillets: Function;
    billets: any;
    setBillets: Function;
    setBilletOrigin: Function;
};

export function CashFundTickets({
    alertForm,
    isControleActive,
    totalBillets,
    TotalBillets,
    billets,
    setBillets,
    setBilletOrigin,
}: CashFundAlert) {
    const { t } = useTranslation();

    const handleAmountBilletsChange = (event: any, key: any) => {
        let newBillets = [...billets] as any;
        newBillets[key].quantiteretire = event;
        setBillets(newBillets);
    };

    React.useEffect(() => {
        TotalBillets();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [totalBillets]);

    React.useEffect(() => {
        setBilletOrigin(billets);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [billets]);

    return (
        <React.Fragment>
            <Col xl="6">
                <div>
                    <StyledH2 className="m-3">{t("Tickets")}</StyledH2>
                    <fieldset
                        className="border px-2 mx-3"
                        style={{ height: "480px" }}
                    >
                        <Row>
                            <Col
                                xl="4"
                                className="my-2 d-flex align-items-center justify-content-center justif-content-center"
                            >
                                <h5
                                    style={{
                                        color: "black",
                                        marginLeft: "30px",
                                    }}
                                >
                                    {t("Denomination")}
                                </h5>
                            </Col>
                            <Col
                                xl="4"
                                className="my-2 d-flex align-items-center justify-content-center justif-content-center"
                            >
                                <h5
                                    style={{
                                        color: "black",
                                        marginLeft: "14px",
                                    }}
                                >
                                    {t("Amount to leave")}
                                </h5>
                            </Col>
                            <Col
                                xl="4"
                                className="my-2 d-flex align-items-center justify-content-center justif-content-center"
                            >
                                <h5 style={{ color: "black" }}>
                                    {t("Maximum capacity")}
                                </h5>
                            </Col>
                        </Row>
                        <Row>
                            {billets.map((b: any, key: number) => (
                                <>
                                    <Col
                                        xl="4"
                                        style={{
                                            color: "black",
                                            font:
                                                "normal normal normal 20px/32px Segoe UI",
                                        }}
                                        className="d-flex  my-1 align-items-center  justify-content-center px-2 "
                                    >
                                        <span
                                            className="d-flex justify-content-end  col-6 "
                                            style={{ textAlign: "end" }}
                                        >
                                            {b.denomination.toFixed(2)} €
                                        </span>
                                    </Col>

                                    <Col
                                        xl="3"
                                        className="my-1 d-flex align-items-center justify-content-center justif-content-center"
                                    >
                                        <NumInput
                                            autoComplete="off"
                                            className={classNames(
                                                "placeholder__clz",
                                                "numInput__clz",
                                                "ml-5"
                                            )}
                                            type="number"
                                            placeholder={
                                                alertForm === t("By number")
                                                    ? "0"
                                                    : "0%"
                                            }
                                            id="example-input"
                                            name="example-input"
                                            onFocus={(e: any) =>
                                                (e.target.placeholder = "")
                                            }
                                            onBlur={(e: any) => {
                                                alertForm === t("By number")
                                                    ? (e.target.placeholder =
                                                          "0")
                                                    : (e.target.placeholder =
                                                          "0%");
                                            }}
                                            disabled={!isControleActive}
                                            format={(o) =>
                                                alertForm === t("By number")
                                                    ? `${o}`
                                                    : `${o} %`
                                            }
                                            value={
                                                b.quantiteretire !== 0
                                                    ? b.quantiteretire
                                                    : null
                                            }
                                            onChange={(e: any) => {
                                                handleAmountBilletsChange(
                                                    e,
                                                    key
                                                );

                                                if (
                                                    (b.quantiteretire <=
                                                        b.quantitedispo &&
                                                        alertForm ===
                                                            t("By number")) ||
                                                    (b.quantiteretire <= 100 &&
                                                        alertForm ===
                                                            t("By percentage"))
                                                ) {
                                                    setIsValidateCashFundForum(
                                                        true
                                                    );
                                                    TotalBillets();
                                                } else {
                                                    setIsValidateCashFundForum(
                                                        false
                                                    );
                                                }
                                            }}
                                            max={
                                                alertForm === t("By number")
                                                    ? b.quantitedispo
                                                    : 100
                                            }
                                            min={0}
                                            strict
                                        />
                                    </Col>
                                    <Col
                                        xl="1"
                                        className="my-1 px-1 d-flex align-items-center justify-content-center justif-content-center"
                                    >
                                        {alertForm === t("By number") ? (
                                            ""
                                        ) : (
                                            <div
                                                style={{
                                                    marginLeft: "9px",
                                                }}
                                            >
                                                (
                                                {(
                                                    ((b.quantiteretire *
                                                        b.quantitedispo) /
                                                        100) *
                                                    b.denomination
                                                ).toFixed(2)}
                                                <span
                                                    style={{
                                                        marginLeft: "2px",
                                                    }}
                                                >
                                                    €
                                                </span>
                                                )
                                            </div>
                                        )}
                                    </Col>
                                    <Col
                                        xl="4"
                                        className=" my-1 d-flex align-items-center justify-content-center justif-content-center"
                                        style={{
                                            color: "#BE0A0A",
                                            font:
                                                "normal normal normal 20px/32px Segoe UI",
                                        }}
                                    >
                                        {b.quantitedispo} €{" "}
                                    </Col>
                                </>
                            ))}
                        </Row>
                    </fieldset>
                </div>
                <fieldset
                    className="border pl-2 mx-3"
                    style={{ height: "40px" }}
                >
                    <h5 style={{ color: "black" }} className="mt-2">
                        {t("Total tickets")}:{" "}
                        {totalBillets > 0 ? totalBillets.toFixed(2) : "0.00"} €
                    </h5>
                </fieldset>
            </Col>
        </React.Fragment>
    );
}
